
import { Component, Vue } from "vue-property-decorator";
// import Navbar from "@/components/Utility/Navbar.vue";
// import Footer from "@/components/Utility/Footer.vue";

@Component({
  components: {
    // Navbar,
    // Footer,
  },
})
export default class QA extends Vue {
  // body 底色改為 QA 頁面底色（樣式見 QA.scss 的 body.qa-body），內容較短時下方不露出白底
  mounted(): void {
    document.body.classList.add("qa-body");
  }

  beforeDestroy(): void {
    document.body.classList.remove("qa-body");
  }
}
